module.exports = __webpack_public_path__ + "img/inst-12.f6584167.png";